/**
 * Internal depedencies
 */
import * as actions from 'state/action-types';

export default () => ({
	type: actions.STARTUP_LOADED_SUCCESS,
});
